export const NAVIGATE = 'NAVIGATE';

export function Navigate(redirectTo) {
  return {
    type: NAVIGATE,
    payload: redirectTo
  };
}
